export default __webpack_public_path__ + "static/media/report-abuse-new.d15d2a55.svg";